export default [
    { label: 'Category Name', name: 'name' }
];